import { useContext, useEffect, useMemo, useRef, useState } from "react"
import LocalAnimations from "@/assets/AppAssets/animation/AnimationConfig.json"
import TemplateData from "@/config/template.json"
import './index.scss'
import { FilterContext } from "@/App"
import { RENDER_SDK, RESOURCE_MANAGER } from "@/config"
import { Col, Row } from "antd"
import { AvatarContext } from "@/components/RenderComp/Avatar"
import { RendererContext } from "@/components/FURenderkit"
import { FUImageBackground } from "@/packages/types/FUImageBackground"
import { SceneContext } from "@/components/RenderComp/Scene"
import { getImagePixelInfo } from "@/utils"
const resourceBaseUrl = 'https://sdk.faceunity.com/demo/'
type TemplateDataType = typeof TemplateData
type TemplateKeys = keyof TemplateDataType
export type TempType = TemplateDataType[TemplateKeys][number]

const TempComp = (props) => {
    const {
        temp,
        templateId,
        setPlayStatus,
        setPreviewUrl,
        setPreviewPosterUrl,
        setTemplate,
    } = props
    return (
        <Col
            span={24}
            key={temp.id}
            className={
                templateId === temp.id
                    ? 'template-item active'
                    : 'template-item '
            }
            onClick={() => {
                console.log(temp)
                setPlayStatus(false)
                setPreviewUrl(resourceBaseUrl + temp.preview)
                setPreviewPosterUrl(resourceBaseUrl + temp.id + '.png')
                setTemplate(temp)
            }}
        >
            <img className="bundle-icon" src={resourceBaseUrl + temp.id + '.png'} alt="" />
        </Col>
    )
}

const TemplateList = (props) => {
    const {
        setPlayStatus,
        setPreviewUrl,
        setPreviewPosterUrl,
        templateId,
        setTemplate,
    } = props
    const { comp, renderer } = useContext(RendererContext)
    const { scene } = useContext(SceneContext)
    const { avatarConfig, avatar } = useContext(AvatarContext) as FilterContext<typeof AvatarContext>
    const backgroundInstanceRef = useRef<FUImageBackground>()
    const foregroundInstanceRef = useRef<FUImageBackground>()
    const gender = useMemo(() => {
        return avatarConfig?.data.gender as string || 'female'
    }, [avatarConfig])

    const setBackgroundImg = ({ img, imgdata }) => {
        console.log('scene', scene)
        if (!scene) return
        clearBackgroundImg()
        backgroundInstanceRef.current = scene.addImageBackground()
        // 操作wasm内存
        let datastr = RENDER_SDK.wasmCtx.module._malloc(imgdata.length)
        RENDER_SDK.wasmCtx.module.HEAP8.set(imgdata, datastr)

        backgroundInstanceRef.current.update(
            datastr,
            img.width,
            img.height,
            4,
            RENDER_SDK.ESpriteFitType.SPRITE_SHAPE_FILL,
            [0, 0],
            [1, 1],
            0
        )
    }
    const setForegroundImg = ({ img, imgdata }) => {
        if (!scene) return
        clearBackgroundImg()
        foregroundInstanceRef.current = scene.addImageForeground()
        // 操作wasm内存
        let datastr = RENDER_SDK.wasmCtx.module._malloc(imgdata.length)
        RENDER_SDK.wasmCtx.module.HEAP8.set(imgdata, datastr)

        foregroundInstanceRef.current.update(
            datastr,
            img.width,
            img.height,
            4,
            RENDER_SDK.ESpriteFitType.SPRITE_SHAPE_FILL,
            [0, 0],
            [1, 1],
            0
        )
    }
    const clearBackgroundImg = () => {
        if (backgroundInstanceRef.current) {
            backgroundInstanceRef.current.clear()
            backgroundInstanceRef.current = undefined
        }
    }
    const selectTemp = async (temp: TempType) => {
        if (!scene) return

        console.log('render', temp)
        const sceneConfig = temp.scene[gender as 'female' | 'male']
        const fetchlist: Promise<any>[] = []
        const callBackList: Function[] = []
        if (sceneConfig.avatars) {
            const avatarConfig = sceneConfig.avatars[0]
            const animationBundle = avatarConfig.animations[0]
            fetchlist.push(RESOURCE_MANAGER.prepareData(animationBundle))
            callBackList.push((path) => {
                avatar.setAnimation(path, 'DefaultAnimNode', true)
            })
        }
        if (sceneConfig.background) {
            const backgroundBundle = sceneConfig.background[0].url
            if (backgroundBundle.endsWith('.bundle')) {
                fetchlist.push(RESOURCE_MANAGER.prepareData(backgroundBundle))
                callBackList.push((path) => scene.addBackground(path))
            } else {
                fetchlist.push(new Promise(resolve => {
                    let img = new Image() //手动创建一个Image对象
                    img.src = backgroundBundle //创建Image的对象的url
                    img.onload = async () => {
                        const imgdata = getImagePixelInfo(
                            img,
                            img.width,
                            img.height
                        )
                        resolve({ img, imgdata })
                    }
                }))
                callBackList.push(setBackgroundImg)

            }
        }
        if (sceneConfig.foreground) {
            const foregroundBundle = sceneConfig.foreground[0].url
            if (foregroundBundle.endsWith('.bundle')) {
                fetchlist.push(RESOURCE_MANAGER.prepareData(foregroundBundle))
                callBackList.push((path) => scene.addForeground(path))
            } else {
                fetchlist.push(new Promise(resolve => {
                    let img = new Image() //手动创建一个Image对象
                    img.src = foregroundBundle //创建Image的对象的url
                    img.onload = async () => {
                        const imgdata = getImagePixelInfo(
                            img,
                            img.width,
                            img.height
                        )
                        resolve({ img, imgdata })
                        callBackList.push(({ img, imgdata }) => setForegroundImg({ img, imgdata }))
                    }
                }))
            }
        }
        if (sceneConfig.camera) {
            const cameraBundle = sceneConfig.camera
            fetchlist.push(RESOURCE_MANAGER.prepareData(cameraBundle))
            callBackList.push((path) => {
                scene.setCamera(path)
            })
        }
        if (sceneConfig.lights) {
            const lightsBundle = sceneConfig.lights[0]
            fetchlist.push(RESOURCE_MANAGER.prepareData(lightsBundle))
            callBackList.push((path) => {
                scene.addLight(path)
            })
        }
        if ((sceneConfig as unknown as any).position) {
            avatar.setPosition((sceneConfig as unknown as any).position)
        }
        const result = await Promise.all(fetchlist)
        callBackList.forEach((fn, index) => {
            fn(result[index])
        })
    }

    useEffect(() => {
        if (comp) {
            const temp = TemplateData[comp as string][0]
            setPreviewUrl(resourceBaseUrl + temp.preview)
            setPreviewPosterUrl(resourceBaseUrl + temp.id + '.png')
            setTemplate(temp)
        }
    }, [comp])

    useEffect(() => {
        const container = document.getElementById('fu-renderkit-container')
        const canvas = document.getElementById('canvas')
        if (templateId && avatar) {
            const temp = TemplateData[comp as string].find(item => item.id === templateId)
            // selectTemp(temp)
            setTimeout(() => {
                if (container && canvas) {
                    canvas.style.width = temp.output.width / 2 + 'px'
                    canvas.style.height = temp.output.height / 2 + 'px'
                    renderer?.resize()
                }
            }, 300)
        }
    }, [avatar, templateId])

    return (
        <div className="template-content" >
            <div
                className="template-list"
                style={{
                    display: 'flex'
                }}
            >
                <div>
                    {
                        TemplateData[comp as string]?.filter((_, index) => index % 2 === 0)
                            .map(temp => (
                                <TempComp
                                    temp={temp}
                                    templateId={templateId}
                                    setPlayStatus={setPlayStatus}
                                    setPreviewUrl={setPreviewUrl}
                                    setPreviewPosterUrl={setPreviewPosterUrl}
                                    setTemplate={setTemplate}
                                />
                            ))
                    }
                </div>
                <div>
                    {
                        TemplateData[comp as string]?.filter((_, index) => index % 2 !== 0)
                            .map(temp => (
                                <TempComp
                                    temp={temp}
                                    templateId={templateId}
                                    setPlayStatus={setPlayStatus}
                                    setPreviewUrl={setPreviewUrl}
                                    setPreviewPosterUrl={setPreviewPosterUrl}
                                    setTemplate={setTemplate}
                                />
                            ))
                    }
                </div>
            </div>
        </div>
    )
}

export default TemplateList
